import { SIFJournal } from "./SIFJournal";
export default SIFJournal;
